export const FEATURE_TYPE_PROPERTY = "type";
export const FEATURE_DATA_PROPERTY = "data";
